export const banner = {
  api: 'bannerEndpoint/getBanners',
  get: 'backend/flexible/v2/cms/getBanners',
  home: 'backend/flexible/v2/cms/getBannersHome',
};
